import { plural } from '@cian/utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackRemoveConfirm } from './tracking';
import { ModalFooter, ModalRemoveFromFavoritesContent } from '../../../components/MassActions/remove';
import { ModalConfirm } from '../../../components/ModalConfirm';
import { useFavoritesUxfeedbackCampaign } from '../../../hooks/uxfeedback';
import { selectFilters, selectSelectedProducts } from '../../../selectors';
import { removeByIds } from '../../../thunk/favorites';
import { EEntityType } from '../../../types/filters';
import { doNotShowModalRemoveFromFavorites } from '../../../utils/remove';

interface IProps {
  entityId?: number;
  onClose(): void;
}

export function ModalConfirmRemoveContainer({ entityId, onClose }: IProps) {
  const dispatch = useDispatch();

  const [doNotShow, setDoNotShow] = React.useState(false);
  const selectedProducts = useSelector(selectSelectedProducts);
  const { favoriteEntityType } = useSelector(selectFilters);
  const count = selectedProducts.length;

  const { sendFavoritesUxfeedbackCampaign } = useFavoritesUxfeedbackCampaign();

  const handleConfirm = () => {
    if (doNotShow) {
      doNotShowModalRemoveFromFavorites();
    }

    trackRemoveConfirm(selectedProducts);
    dispatch(removeByIds(entityId));
    onClose();
    sendFavoritesUxfeedbackCampaign();
  };

  let confirmText;
  if (entityId) {
    confirmText = 'Удалить из избранного?';
  } else {
    confirmText = `Удалить ${count} ${plural(count, ['объявление', 'объявления', 'объявлений'])} из избранного?`;
  }

  return (
    <ModalConfirm
      text={confirmText}
      footer={<ModalFooter onConfirm={handleConfirm} onCancel={onClose} />}
      onClose={onClose}
      isVisible={true}
    >
      {favoriteEntityType !== EEntityType.Newbuilding && (
        <ModalRemoveFromFavoritesContent checked={doNotShow} onChange={checked => setDoNotShow(checked)} />
      )}
    </ModalConfirm>
  );
}
